export class TransactionModel
{
    txn_no: string
    cust_code: string
    cust_name: string
    shipto_code: string
    shipto_name: string
    ttl_ord_amt: string
    status: string
    delivery_status: string
    txn_datetime: string
    u_txn_datetime: string
    order_status: string
    inv_no: string
    created_date: string
    u_created_date: string
    total: number
    so_no: string
    remarks: string
    ftp_fail_ind: string
    po_no: string
    viewable: string
    division: string

    title: string
    order_status_desc: string
    div_class: string
    icon: string
    icon_class: string

    po_date: string
    so_date: string
    sd_block_date: string
    sd_release_date: string
    fi_block_date: string
    fi_release_date: string
    do_date: string
    pgi_date: string
    inv_date: string
    despatch_date: string
    shipment_date: string
    cust_receipt_date: string
    cust_reject_date: string
    estimated_arrival_date: string

    ord_type_desc: string
    ord_type: string
    sales_ind: string
    order_reason: string
    is_for_client_sap:string
    tick: string
}


// WEBPACK FOOTER //
// ./src/models/order/transaction.model.ts